import React from 'react';
import PropTypes from 'prop-types';
import HomeAppRow from "../components/HomeAppRow";
import styles from "./ARMHome.module.scss";

const ARMHome = (props) => {
  return (
    <div className={styles.container}>
      {props.Apps.map(app => {
        if (app.image) {
            let appKey = '';
            if (app.name && app.order) {
              const appName = app.name.replace(' ', '_');
              appKey = `${appName}_${app.order}`;
            }
          return <HomeAppRow ARMApp={app} key={appKey} />
        }
      })}
    </div>
  );
};

ARMHome.propTypes = {
  Apps: PropTypes.array.isRequired,
}

export default ARMHome;
